
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import { useAdminStatus } from "@/hooks/useAdminStatus";

export const AddReviewSection = () => {
  const { t } = useTranslation();
  const { user } = useAdminStatus();
  
  return (
    <section className="mt-8 text-center">
      <h2 className="text-2xl font-semibold mb-4">
        {t('share_experience')}
      </h2>
      <p className="text-muted-foreground mb-6">
        {t('help_photographers')}
      </p>
      {user ? (
        <Link to="/review/new">
          <Button size="lg">
            {t('add_review')}
          </Button>
        </Link>
      ) : (
        <Link to="/auth">
          <Button size="lg">
            {t('sign_in_to_review')}
          </Button>
        </Link>
      )}
    </section>
  );
};
